import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscountTemplatesComponent } from './discount-templates.component';
import { DiscountTemplatesRoutingModule } from './discount-templates-routing.module';
import { CreateDiscountTemplateComponent } from './create-discount-template/create-discount-template.component';
import { EditDiscountTemplateComponent } from './edit-discount-template/edit-discount-template.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule, FormFieldModule } from 'src/app/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import { CreateGeneralDiscountTemplateComponent } from './create-general-discount-template/create-general-discount-template.component';
import { EditGeneralDiscountTemplateComponent } from './edit-general-discount-template/edit-general-discount-template.component';
import { CustmizedDiscountTemplatesComponent } from './custmized-discount-templates/custmized-discount-templates.component';
import { CreateCustmizedDiscountTemplatesComponent } from './create-custmized-discount-templates/create-custmized-discount-templates.component';
import { CreateDomesticCustmizedDiscountTemplatesComponent } from './create-domestic-custmized-discount-templates/create-domestic-custmized-discount-templates.component';
import { CreateProductCustmizedDiscountTemplatesComponent } from './create-product-custmized-discount-templates/create-product-custmized-discount-templates.component';



@NgModule({
  declarations: [
    DiscountTemplatesComponent,
    CreateDiscountTemplateComponent,
    EditDiscountTemplateComponent,
    CreateGeneralDiscountTemplateComponent,
    EditGeneralDiscountTemplateComponent,
    CustmizedDiscountTemplatesComponent,
    CreateCustmizedDiscountTemplatesComponent,
    CreateDomesticCustmizedDiscountTemplatesComponent,
    CreateProductCustmizedDiscountTemplatesComponent,
    
  ],
  imports: [
    CommonModule,
    DiscountTemplatesRoutingModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    FormFieldModule,
    ControlsModule,
    NgbModule,
    ReusableModule
  ]
})
export class DiscountTemplatesModule { }
